import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n\n  &::-webkit-scrollbar {\n    width: 3px;\n    height: 140px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 2px;\n    background: rgba(206, 210, 224, 1);\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  &.filter-menu {\n    margin-top: 8px;\n    padding: 12px;\n\n    .MuiPaper-root {\n      width: 450px;\n      max-height: 400px;\n      padding: 0px 4px;\n      overflow: auto;\n      border-radius: 6px;\n\n      &::-webkit-scrollbar {\n        width: 3px;\n        height: 140px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        border-radius: 2px;\n        background: rgba(206, 210, 224, 1);\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  font-size: 16px;\n  color: rgb(95, 95, 105);\n  font-weight: normal;\n  line-height: 1.5;\n  padding: 0px 0px 0px 12px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  width: 50%;\n  padding: 0;\n  text-wrap: wrap;\n  display: flex;\n  align-items: flex-start;\n  min-height: unset;\n\n  .ant-checkbox-wrapper {\n    padding: 8px 12px;\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 6px;\n  position: sticky;\n  top: 0;\n  width: 100%;\n  left: 0;\n  z-index: 10;\n  padding: 24px 0;\n  background-color: rgba(255, 255, 255, 0.9);\n  margin-bottom: -24px;\n  @media (max-width: 768px) {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BooksMobileFilterListWrapper } from "@/components/Books/List/BookListMobileFilterList";
import { ButtonWithDropdownMenu } from "@/components/Categories/Menu/index";
import { MobileSliderArea } from "@/components/Search";
import { MobileFilterListItem } from "@/components/Search/MobileFilterListItem";
import { MobileFilterSideSheet } from "@/components/Search/MobileFilterSideSheet";
import Icon from "@/components/icon/Icon";
import { ArrowDown, Sizes } from "@/components/icon/IconList";
import { FilterQueryHandlerType } from "@/hooks/useCategoryFilterHandler";
import { useDropdownMenu } from "@/hooks/useDropdownMenu";
import useSearchParams from "@/hooks/useSearchParams";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { SOLVOOKPASS_TEXT } from "@/settings/constant";
import { Menu, MenuItem, styled, useMediaQuery, useTheme } from "@mui/material";
import { Checkbox } from "antd";
import { useRouter } from "next/router";
import * as React from "react";
import { useEffect, useMemo } from "react";
import { DEFAULT_QUERY_SIZE, DetailFilterKeys } from "src/api/category";
import { BaseFilterKeyToLabel } from "src/api/search";
import SelectedFilterWrapper from "./SelectedFilter";
export const DetailFilterButtonList = (param)=>{
    let { filterItems , handleMobileSlider , isCheckFilterItem , isCheckFilterCount , selectedFilterList , mobileFilterSideSheet , filterQueryHandler  } = param;
    const mixpanelTrigger = (name, item)=>{
        mixpanelEvent("Category Filtered", {
            "Filter Type": name === "제작자" ? "저자명" : name,
            "Filter Option Selected": item
        });
    };
    const solvookPassButton = useMemo(()=>{
        return filterItems.find((filter)=>filter.name === SOLVOOKPASS_TEXT && filter.items.length > 0);
    }, [
        filterItems
    ]);
    return /*#__PURE__*/ _jsxs(DetailFilterButtonListContainer, {
        children: [
            solvookPassButton && /*#__PURE__*/ _jsx(ButtonWithDropdownMenu, {
                className: selectedFilterList.find((item)=>item.key === SOLVOOKPASS_TEXT) ? "selected" : "",
                onClick: (e)=>{
                    e.preventDefault();
                    filterQueryHandler({
                        filterType: FilterQueryHandlerType.DETAILFILTER,
                        filterName: solvookPassButton.name,
                        value: solvookPassButton.items[0]
                    });
                    //mx-47
                    mixpanelEvent("Category Filtered", {
                        "Filter Type": "쏠북패스",
                        "Filter Option Selected": "쏠북패스"
                    });
                },
                children: SOLVOOKPASS_TEXT
            }),
            filterItems.map((filter, idx)=>{
                if (filter.items.length > 0 && filter.name !== SOLVOOKPASS_TEXT) return /*#__PURE__*/ _jsx(CustomMenuButton, {
                    filterName: filter.name,
                    items: filter.items,
                    mobileFilterOpen: handleMobileSlider,
                    isCheckFilterItem: isCheckFilterItem,
                    isCheckFilterCount: isCheckFilterCount,
                    children: /*#__PURE__*/ _jsx(CustomMenuButton.MenuItemListLayout, {
                        children: filter.items.map((item, idx)=>{
                            if (!item) return;
                            return /*#__PURE__*/ _jsx(CustomMenuButton.MenuItem, {
                                checked: isCheckFilterItem(filter.name, item),
                                onChange: ()=>{
                                    filterQueryHandler({
                                        filterType: FilterQueryHandlerType.DETAILFILTER,
                                        filterName: filter.name,
                                        value: item
                                    });
                                    //mx-47
                                    mixpanelTrigger(filter.name, item);
                                },
                                children: item
                            }, filter.name + idx + item);
                        })
                    })
                }, idx);
            }),
            /*#__PURE__*/ _jsx(MobileSliderArea, {
                children: /*#__PURE__*/ _jsxs(MobileFilterSideSheet, {
                    title: "상세 필터",
                    sliderOpen: mobileFilterSideSheet,
                    openSlider: handleMobileSlider,
                    children: [
                        selectedFilterList.length > 0 && /*#__PURE__*/ _jsx(SelectedFilterWrapper, {
                            position: "sideSheet",
                            button: /*#__PURE__*/ _jsx(SelectedFilterWrapper.ResetButton, {
                                handleResetFilter: ()=>filterQueryHandler({
                                        filterType: FilterQueryHandlerType.RESET
                                    })
                            }),
                            children: selectedFilterList.map((item, idx)=>{
                                return /*#__PURE__*/ _jsx(SelectedFilterWrapper.SelectedItem, {
                                    label: item.value,
                                    onRemove: ()=>filterQueryHandler({
                                            filterType: FilterQueryHandlerType.DETAILFILTER,
                                            filterName: item.key,
                                            value: item.value
                                        })
                                }, "selectedItem" + idx);
                            })
                        }),
                        /*#__PURE__*/ _jsx(BooksMobileFilterListWrapper, {
                            children: /*#__PURE__*/ _jsx("ul", {
                                children: filterItems.map((key, idx)=>{
                                    const newFilters = key.items.map((item)=>{
                                        return {
                                            id: item,
                                            value: item
                                        };
                                    });
                                    if (key.items.length > 0) return /*#__PURE__*/ _jsx("li", {
                                        children: /*#__PURE__*/ _jsx(MobileFilterListItem, {
                                            title: key.name,
                                            filterItem: newFilters,
                                            handleFilter: (filterType, id, value)=>{
                                                filterQueryHandler({
                                                    filterType: FilterQueryHandlerType.DETAILFILTER,
                                                    filterName: filterType,
                                                    value: id.toString()
                                                });
                                                //mx-47
                                                mixpanelTrigger(filterType, id);
                                            },
                                            selectedFilters: selectedFilterList,
                                            openSlider: handleMobileSlider,
                                            sliderOpen: mobileFilterSideSheet
                                        })
                                    }, idx);
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
export const CustomMenuButton = (param)=>{
    let { filterName , mobileFilterOpen , isCheckFilterCount , children  } = param;
    const buttonRef = React.useRef(null);
    const { handleOpen , handleClose , open , anchorEl , setAnchorEl  } = useDropdownMenu();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const searchParams = useSearchParams();
    const menuNameToKorean = BaseFilterKeyToLabel[filterName] || filterName;
    const handleClick = (event)=>{
        if (isMobile) {
            mobileFilterOpen(true, menuNameToKorean);
            return;
        }
        handleOpen(event);
    };
    // hotfix: 기본적으로 클릭을 해야 매뉴 버튼이 오픈을 하는데, 단원 필터를 켜줘야 하기 때문에 여기서 open을 시켜줍니다.
    const { asPath  } = useRouter();
    useEffect(()=>{
        const { innerWidth: width  } = window;
        const sm = theme.breakpoints.values.sm;
        if (!buttonRef.current) return;
        if (!searchParams.get("id")) return;
        // 이 컴포넌트를 사용하는 페이지가 카테고리 페이지에서만 사용하는걸 가정으로 가벼운 includes 추가하였습니다
        // 추후 걷어질 훅이라 주석과 함께 남겨두겠습니다.
        // 25.03.04
        if (asPath.includes("edition")) return;
        if (Array.from(searchParams.keys()).length > DEFAULT_QUERY_SIZE) return;
        if (width < sm) {
            if (filterName === DetailFilterKeys.UNITS) mobileFilterOpen(true, menuNameToKorean);
            return;
        }
        if (filterName === DetailFilterKeys.UNITS) {
            setAnchorEl(buttonRef.current);
        }
    }, [
        searchParams.get("id")
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(ButtonWithDropdownMenu, {
                ref: buttonRef,
                id: "filter-button",
                className: isCheckFilterCount(filterName) ? "selected" : "",
                "aria-controls": open ? "filter-menu" : undefined,
                "aria-haspopup": "true",
                "aria-expanded": open ? "true" : undefined,
                onClick: handleClick,
                children: [
                    menuNameToKorean,
                    isCheckFilterCount(filterName) ? " ".concat(isCheckFilterCount(filterName)) : "",
                    /*#__PURE__*/ _jsx(Icon, {
                        icon: ArrowDown,
                        size: Sizes.small,
                        color: "rgba(106, 112, 138, 1)"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CustomMenu, {
                className: "filter-menu",
                id: "filter-menu",
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                MenuListProps: {
                    "aria-labelledby": "basic-button"
                },
                children: children
            })
        ]
    });
};
export const CheckboxMenuItem = (param)=>{
    let { checked , onChange , children , props  } = param;
    return /*#__PURE__*/ _jsx(CustomMenuItem, {
        children: /*#__PURE__*/ _jsx(Checkbox, {
            checked: checked,
            onChange: onChange,
            children: /*#__PURE__*/ _jsx(TypographyText, {
                children: children
            })
        })
    });
};
export const MenuListContainer = styled("div")(_templateObject());
CustomMenuButton.MenuItemListLayout = MenuListContainer;
CustomMenuButton.MenuItem = CheckboxMenuItem;
export const CustomMenu = styled(Menu)(_templateObject1());
export const TypographyText = styled("p")(_templateObject2());
export const CustomMenuItem = styled(MenuItem)(_templateObject3());
const DetailFilterButtonListContainer = styled("div")(_templateObject4());
